import { Container, Title, Contents, More } from './SecondaryCardStyles';

interface SecondaryCardProps {
  title: string;
  contents: string;
  btnLable?: string;
  onClick?: () => void;
}

const SecondaryCard = ({ title, contents, btnLable, onClick }: SecondaryCardProps) => {
  return (
    <Container>
      <Title>
        <div className="text-text-500">{title}</div>
      </Title>
      <Contents>
        <div className="text-text-500 text-sm">{contents}</div>
      </Contents>
      {btnLable ? (
        <More onClick={onClick}>
          <div className="text-primary-500 text-sm">{btnLable}</div>
        </More>
      ) : null}
    </Container>
  );
};

export default SecondaryCard;
